import React, { useContext } from 'react';
import { ActionBar } from 'common';
import { Box, Card, CardContent, Stack } from '@mui/material';
import * as R from 'ramda';
import { CreateCustomerAuthContext } from '../Create';
import TitleBar from '../TitleBarConnector';
import CustomerInformationAccordion from '../../components/CustomerInformationAccordion';
import ProductsAccordion from '../../components/ProductsAccordion';
import TerminalsAccordion from '../../components/TerminalsAccordion';
import DestinationsAccordion from '../../components/DestinationsAccordion';
import CarrierSelection from '../../components/CarrierSelection';

const stackStyles = {
  /* eslint-disable sort-keys-fix/sort-keys-fix */
  mx: 'auto',
  pt: { xs: 6, lg: 9 },
  pb: 10,
  width: { xs: 1, lg: 760 },
};

const cardStyles = {
  /* eslint-disable sort-keys-fix/sort-keys-fix */
  m: theme => ({ xs: theme.spacing(0, 'auto', 10.5), lg: theme.spacing(3, 'auto', 12) }),
  p: { xs: 2, lg: 3 },
  pb: { xs: 0, lg: 3 },
  width: { xs: 1, lg: 760 },
};

const Carriers = () => {
  const { info, setInfo } = useContext(CreateCustomerAuthContext);
  const {
    authorizationType,
    carriers,
    controlNumbers,
    controlType,
    isCarrierRestricted,
    terminals,
    products,
  } = info;

  const isContinueDisabled = R.equals('true', isCarrierRestricted) && !carriers.length;

  return (
    <>
      <TitleBar />
      <Stack spacing={2} sx={stackStyles}>
        <CustomerInformationAccordion customerAuthorization={info} />
        <Box>
          <TerminalsAccordion controlType={controlType} terminals={terminals} />
        </Box>
        <Box>
          <ProductsAccordion authorizationType={authorizationType} products={products} />
        </Box>
        <Box>
          <DestinationsAccordion destinations={controlNumbers} showItn />
        </Box>
        <Card sx={cardStyles}>
          <CardContent sx={{ ':last-child': { p: 0 } }}>
            <CarrierSelection
              info={info}
              isCarrierRestricted={isCarrierRestricted}
              setInfo={setInfo}
            />
          </CardContent>
        </Card>
      </Stack>
      <ActionBar
        backLink="../loading-control-numbers"
        continueLabel="Review"
        continueLink="../summary"
        disableAction={isContinueDisabled}
      />
    </>
  );
};

export default Carriers;
